import './ContactBar.css';
import { FaTelegramPlane } from "react-icons/fa";

export default function ContactBar({ number1, number2 }) {
  return (
    <div className="contact-bar">

      {/* LEFT: BRAND */}
      <div className="brand-pill">
        <span className="icon-warning">⚠️</span>

        <span className="brand-text">
          DpBoss Name is A Brand
        </span>
      </div>

      {/* RIGHT: CONTACTS */}
      <div className="contact-right">

        <a
          href={`https://t.me/${number2?.replace(/\s/g, '')}`}
          className="contact-pill telegram-vertical"
          target="_blank"
          rel="noreferrer"
        >
          <FaTelegramPlane size={24} color="#0088cc" />
          <span className="tg-text">Telegram</span>
        </a>

      </div>

    </div>
  );
}